import { isObject } from '@/utils/validate'

const LOADED = {}
const LOAD_TIMEOUT_MS = 150_000

const removeScriptBySrc = (src) => {
  const existingScript = document.querySelector(`script[src="${src}"]`)
  if (existingScript) {
    document.head.removeChild(existingScript)
    delete LOADED[src]
  }
}

const removeScriptById = (id) => {
  const existingScript = document.getElementById(id)
  if (existingScript && existingScript.tagName === 'SCRIPT') {
    const src = existingScript.src
    document.head.removeChild(existingScript)
    if (src) {
      delete LOADED[src]
    }
  }
}

const addScriptTag = (src, attributes, onLoad, onError) => {
  // Remove old script by ID if provided, otherwise by src
  if (isObject(attributes) && attributes.id) {
    removeScriptById(attributes.id)
  } else {
    removeScriptBySrc(src)
  }

  const script = document.createElement('script')

  script.src = src
  script.type = 'text/javascript'
  script.async = true
  script.crossorigin = 'anonymous'

  script.onload = onLoad
  script.onerror = onError

  // Set custom attributes before appending
  if (isObject(attributes)) {
    Object.entries(attributes).forEach(([key, value]) => {
      script[key] = value
    })
  }

  document.head.appendChild(script)

  return () => {
    // return remove function
    if (script.parentNode) {
      document.head.removeChild(script)
    }
    delete LOADED[src]
  }
}

/**
 * Inject a script with given src to body, ready to use.
 * Return a cleanup function to remove if applicable
 */
const loadRemoteScript = (
  src,
  {
    onSuccess,
    onError,
    onTimeout,
    attributes = {},
    timeoutMs = LOAD_TIMEOUT_MS,
    cancelOnTimeout = false,
  } = {}
) => {
  let timeoutId = null
  let isCancelled = false

  const handleSuccess = (event) => {
    if (isCancelled) {
      return
    }

    LOADED[src] = true

    clearTimeout(timeoutId)

    if (typeof onSuccess === 'function') {
      onSuccess(event)
    }
  }

  const handleError = (event) => {
    if (isCancelled) {
      return
    }

    console.warn('loadRemoteScript error', { src })

    clearTimeout(timeoutId)

    if (typeof onError === 'function') {
      onError(event)
    }
  }

  if (LOADED[src]) {
    return handleSuccess()
  }

  const cleanupFn = addScriptTag(src, attributes, handleSuccess, handleError)

  const handleTimeout = () => {
    console.warn('loadRemoteScript timeout', { src, cancelOnTimeout })

    if (cancelOnTimeout) {
      isCancelled = true
      cleanupFn()
    }

    if (typeof onTimeout === 'function') {
      onTimeout()
    }
  }

  timeoutId = setTimeout(handleTimeout, timeoutMs)

  return cleanupFn
}

export { loadRemoteScript, addScriptTag, removeScriptBySrc, removeScriptById }
